import { render, staticRenderFns } from "./RoomDisabilities.vue?vue&type=template&id=7062afb0&"
import script from "./RoomDisabilities.vue?vue&type=script&lang=js&"
export * from "./RoomDisabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports